var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',{staticClass:"sr-only"},[_vm._v("Produk Charm")]),_vm._v(" "),_c('div',{staticClass:"overflow-hidden"},[_c('ProductCategoryBannerSlider')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }